// extracted by mini-css-extract-plugin
export default {"recos":"o7-z","productCardOverride":"p7-z","rowHasBadge":"q7-z"};